var _classCallCheck = require("/codebuild/output/src2530/src/s3/01/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/codebuild/output/src2530/src/s3/01/node_modules/@babel/runtime/helpers/createClass.js");
var _possibleConstructorReturn = require("/codebuild/output/src2530/src/s3/01/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/codebuild/output/src2530/src/s3/01/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _inherits = require("/codebuild/output/src2530/src/s3/01/node_modules/@babel/runtime/helpers/inherits.js");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Loan = require('./Loan');
var MonthlyFixedAmortizationLoan = /*#__PURE__*/function (_Loan) {
  "use strict";

  _inherits(MonthlyFixedAmortizationLoan, _Loan);
  function MonthlyFixedAmortizationLoan() {
    _classCallCheck(this, MonthlyFixedAmortizationLoan);
    return _callSuper(this, MonthlyFixedAmortizationLoan, arguments);
  }
  _createClass(MonthlyFixedAmortizationLoan, [{
    key: "calculatePayments",
    value: function calculatePayments() {
      var payments = [];
      var repaymentTime = this.getRepaymentTime();
      var a = this.amount;
      var amortization = this.amount / repaymentTime;
      var i = this.interest / 12;
      for (var j = 0; j < Math.floor(repaymentTime); j += 1) {
        amortization = Math.min(amortization, a);
        var payment = amortization + a * i + this.administrationFee;
        payments.push(payment);
        a -= amortization;
      }
      if (this.monthlyPayment != null) {
        payments.push(a);
      }
      return payments;
    }
  }, {
    key: "calculateRepaymentTime",
    value: function calculateRepaymentTime() {
      var i = this.interest / 12;
      var a = this.amount;
      var f = this.administrationFee;
      var m0 = this.monthlyPayment;
      var amortization = m0 - i * a - f;
      return a / amortization;
    }
  }]);
  return MonthlyFixedAmortizationLoan;
}(Loan);
module.exports = MonthlyFixedAmortizationLoan;